<template>
	<v-card flat rounded="0">
		<v-card-title primary-title>
			<v-row dense justify="space-between">
				<v-col cols="12" sm="8">
					<div
						v-if="$vuetify.breakpoint.mdAndDown"
						:class="`primary--text text-overline ml-2 ${
							$vuetify.breakpoint.xs ? 'text-center' : ''
						}`"
					>
						Seguimiento estado detalle ofertas
					</div>
					<div
						v-else
						class="font-weight-light primary--text text-h4 ml-2 text-capitalize"
					>
						Seguimiento estado detalle ofertas
					</div>
				</v-col>
				<v-col
					sm="4"
					cols="12"
					:class="`d-flex align-center ${
						$vuetify.breakpoint.xs
							? 'justify-center'
							: 'justify-end'
					}`"
				>
				</v-col>
			</v-row>
		</v-card-title>
		<!-- <v-divider class="test"></v-divider> -->
		<v-card-text>
			<v-data-table :headers="headers" :items="searchFuncFiltered" id="seguimientoSecondTable" :item-class="getRowClass">
				<template v-slot:item.id_estado="{ item }">
					{{ statesIds[item.id_estado]['text'] }}
				</template>
				<template v-slot:item.created_date="{ item }">
					{{ formatDate(item.created_date) }}
				</template>
				<template v-slot:item.COF="{ item }">
					{{ item.COF ? 'Nuevo' : 'Existente' }}
				</template>
			</v-data-table>
		</v-card-text>
		<v-row class="d-flex">
			<v-col cols="12" >
				<PieChart :chart-data="pieData" :options="optionsPieChart" />
			</v-col>
			<v-col cols="12" >
				<PieChart :chart-data="pieData2" :options="optionsPieChart" />
			</v-col>
		</v-row>
	</v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { formatDate } from '@/util/libUtil.js';
import PieChart from '@/components/GerenciaTeletrabajo/Stats/PieChart.js';
import statesIds from '@/util/retailX/offerStates.js';

export default {
	name: 'seguimientoOfertasSecond',
	data: () => ({
		statesIds,
		optionsPieChart: {
            maintainAspectRatio: false,
            responsive: true,
            legend: {
				position: 'left',
				align: 'center',
				fullSize: false,
				labels: {
					font: {
					size: 12
					},
					padding: 10
				},
				maxWidth: 9999
            },
        },
		headers: [
			{ text: 'Presupuesto', value: 'offerId' },
			{ text: 'Fecha', value: 'created_date' },
			{ text: 'SFID', value: 'sfid' },
			{ text: 'Comercial', value: 'usuario' },
			{
				text: 'Cliente',
				value: 'cliente',
				width: '300px',
				align: 'center',
			},
			{ text: 'Telefono', value: 'telefono' },
			{ text: 'NIF', value: 'nif' },
			{ text: 'Segmento', value: 'segmento_vf' },
			{ text: 'COF', value: 'COF' },
			{ text: 'C.P.', value: 'cod_postal' },
			{ text: 'Estado', value: 'estado' },
			{ text: 'Tipo', value: 'tipo' },
			{ text: 'Tipo operación', value: 'Tipo_op' },
			{ text: 'Operacion', value: 'operacion' },
			{ text: 'Producto', value: 'producto' },
			{ text: 'Operador', value: 'operador' },
			// { text: 'action', value: 'action' },
			// { text: 'color', value: 'color' },
			{ text: 'id_estado', value: 'id_estado' },
			// { text: 'id_vodafone', value: 'id_vodafone' },
			// { text: 'pdv', value: 'pdv' },
		],
	}),
	components: {
		PieChart,
	},
	methods: {
		formatDate,

		getRowClass(item) {
			return `${statesIds[item.id_estado]['color']} lighten-3`;
		},
		randomHexPastelColor() {
            const r = Math.floor(Math.random() * 256);
            const g = Math.floor(Math.random() * 256);
            const b = Math.floor(Math.random() * 256);
            const a = 0.5;
            return `rgba(${r}, ${g}, ${b}, ${a})`;
        },
        randomPastelColorArrayByLength(length) {
            const colors = [];
            for (let i = 0; i < length; i++) {
                colors.push(this.randomHexPastelColor());
            }
            return colors;
        },
		isVisible() {
			return document.getElementById('seguimientoSecondTable')?.offsetParent === null;
		},
	},
	computed: {		
		searchFuncFiltered() {
			return this.getFiltersByStatesId.length > 0 ?
				this.searchFunc.filter(item => this.getFiltersByStatesId.some((it) => it === item.estado)) :
				this.searchFunc;
		},
		pieData() {
			let data = {}
			
			this.searchFuncFiltered.forEach(element => {
				if(element.estado) {
					if (data[element.estado]) {
						data[element.estado] += 1;
					} else {
						data[element.estado] = 1;
					}
				}
			});

			let colors = Object.keys(data).map((key) => Object.values(statesIds).find((item) => item.text === key)?.pastelHexColor);	
			

			return {
				labels: Object.keys(data),
				datasets: [
					{
						label: Object.keys(data),
						data: Object.values(data),
						backgroundColor: colors,
						hoverOffset: 4,
					},
				],
			};
		},
		pieData2() {
			let data = {}
			
			this.searchFuncFiltered.forEach(element => {
				if(element.producto) {
					if (data[element.producto]) {
						data[element.producto] += 1;
					} else {
						data[element.producto] = 1;
					}
				}
			});

			const colors = this.randomPastelColorArrayByLength(Object.keys(data).length)			

			return {
				labels: Object.keys(data),
				datasets: [
					{
						label: Object.keys(data),
						data: Object.values(data),
						backgroundColor: colors,
						hoverOffset: 4,
					},
				],
			};
		},
		searchFunc() {
			return this.seguimientoOfertasSecond.filter(item => Object.values(item).some(it => it ? String(it).toLocaleLowerCase().includes(String(this.search).toLocaleLowerCase()) : false));
		},
		...mapState('retailX', {
			seguimientoOfertasSecond: (state) => state.seguimientoOfertasSecond,
		}),
		...mapState({
			search: (state) => state.util.navBarSearchField,
		}),
		...mapGetters('retailX', {
			getFiltersByStatesId: 'getFiltersByStatesId',
		}),
	},
	watch: {
		search() {
			this.$forceUpdate();
		},
	},
};
</script>